import { useGenerateManagementKey } from '@api/managementKeys';
import React from 'react';
import { AccessKeyExpiration, AccessKeyType } from 'types/accessKeys';
import { IActionDialogProps } from 'types/common';
import { AccessKeyGenerationDialog } from '../../AccessKeys';

const GenerateDialog: React.FC<IActionDialogProps> = (props) => {
	const mutation = useGenerateManagementKey();
	return (
		<AccessKeyGenerationDialog
			{...props}
			showPermittedProjects
			translationPrefix={AccessKeyType.management}
			generateKey={mutation.mutateAsync}
			defaultExpiration={AccessKeyExpiration.never}
		/>
	);
};

export default GenerateDialog;
